import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-up\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.50001 12V5.20711L10.6465 7.35355L11.3536 6.64645L8.00001 3.29289L4.64645 6.64645L5.35356 7.35355L7.50001 5.20711V12H8.50001Z\" fill=\"#344563\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol